import type { IStock } from '~/@types/assets'
import AssetsAdapter from '@adapters/AssetsAdapter'
import UserAdapter from '@adapters/UserAdapter'
import { defineStore } from 'pinia'

export const useAssetsWatchingStore = defineStore('assetsWatching', {
  state: () => {
    return {
      isLoading: false,
      assetsWatching: [] as Array<IStock>,
    }
  },

  actions: {
    async load(): Promise<void> {
      this.isLoading = true
      this.assetsWatching = await UserAdapter.getAssetsWatching()
      this.isLoading = false
    },

    async watchAsset(id: string): Promise<void> {
      await AssetsAdapter.watchAsset(id)
      await this.load()
    },

    async unwatchAsset(id: string): Promise<void> {
      await AssetsAdapter.unwatchAsset(id)

      await this.load()
    },

  },
})
